import { createContext } from "../util/create-context.js";
import { createDescendantContext } from "../util/hooks/descendants/useDescendant.js";
export const [TabsDescendantsProvider, useTabsDescendantsContext, useTabsDescendants, useTabsDescendant,] = createDescendantContext();
/* State context */
export const [TabsProvider, useTabsContext] = createContext({
    name: "TabsContext",
    hookName: "useTabsContext",
    providerName: "TabsProvider",
    errorMessage: "Tabs.List, Tabs.Tag and Tabs.Panel needs to be wrapped within <Tabs>",
});
//# sourceMappingURL=Tabs.context.js.map